import React from "react";
import { Link } from "@quintype/components";

import { filterStory } from "../../helper/api";
import CollectionName from "../../molecules/collection-name";
import CardImage from "../../atoms/cardimage";
import Headline from "../../atoms/headline";
import StoryDate from "../../atoms/story-date";
import Carousel from "../../atoms/carousel";

import "./slider-with-multiple-big-cards.m.css";

const SliderWithMultipleBigCards = ({ collection }) => {
  if (!(collection && collection.items)) {
    return null;
  }
  const allStories = filterStory(collection);

  if (!allStories.length) {
    return null;
  }

  const stories = allStories.splice(0, 7);

  const getStory = (item, index) => {
    return (
      <div styleName="story-wrapper" key={index}>
        <Link href={`/${item.slug}`}>
          <CardImage story={item} aspectRatio={[2, 3]} imageType="image2x3" widths={[400]} />
        </Link>
        <Link href={`/${item.slug}`}>
          <Headline text={item.headline} headerType={6} headerLevel={1} story={item} />
        </Link>
        <StoryDate story={item} />
      </div>
    );
  };

  return (
    <>
      <CollectionName collection={collection} />
      <div styleName="wrapper">
        <Carousel totalItems={stories.length} showBullets showArrows>
          {stories.map((item, index) => getStory(item, index))}
        </Carousel>
      </div>
    </>
  );
};

export default SliderWithMultipleBigCards;
